import * as z from "zod/v4";
import { BrandAliasSchema } from "./brand-alias";

export const MinimalBrandCompetitorSchema = z.object({
  id: z.bigint(),
  competitorName: z.string(),
  website: z.string(),
  competitiveCategory: z.string(),
});
export type MinimalBrandCompetitor = z.infer<
  typeof MinimalBrandCompetitorSchema
>;

export const BrandCompetitorSchema = MinimalBrandCompetitorSchema.extend({
  competitiveSummary: z.string(),
  competitiveStrengths: z.string(),
  competitiveWeaknesses: z.string(),
  socialSentiment: z.string(),
  aliases: z.array(BrandAliasSchema),
  lastAnalysisAt: z.date().nullable(),
});
export type BrandCompetitor = z.infer<typeof BrandCompetitorSchema>;
